module.exports = __webpack_public_path__ + "media/images/writer/maker-rectangle-banner-a38bf7abc875b400dd3362c3243b689a.png";